import styled from "styled-components"

const Input = styled.input<{error?: boolean}>`
  height: 48px;
  border: 1px solid ${p => p.error ? '#ff5a5f' : 'rgba(0,0,0,0.1)'};
  border-radius: 4px;
  width: 100%;
  background-color: ${p => p.error ? 'rgba(255, 90, 95, 0.05)' : '#fff'};
  :focus {
    border: 1px solid ${p => p.error ? '#ff5a5f' : 'rgba(0,0,0,0.1)'}
  }
`

export default Input

